<script lang="ts">
const WHEEL_CENTERS_X = [19, 43];

const SIDE_WINDOWS_X = [13, 20.5, 28, 35.5];

// Two sparkles in turn behind the bus, so that one is always on its way out.
const TRAIL = [
    { x: 6, y: 9, delay: '0s' },
    { x: 4.5, y: 17, delay: '0.6s' },
];
</script>

<script setup lang="ts">
// PROPS
interface Props {
    /** The wait runs long: the road tilts and the bus takes the climb, slower. */
    isUphill?: boolean;
}

const { isUphill = false } = defineProps<Props>();
</script>

<template>
    <svg viewBox="0 0 52 26" class="h-5.5 w-11 shrink-0 overflow-visible" aria-hidden="true">
        <g class="origin-bottom transition-transform duration-700 [transform-box:fill-box]" :class="{ '-rotate-6': isUphill }">
            <!-- The dashes run backwards: the bus drives on without moving. -->
            <line
                x1="9"
                y1="25"
                x2="52"
                y2="25"
                stroke="var(--color-fl-blue-300)"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-dasharray="4 3"
                :class="isUphill ? 'motion-safe:animate-bus-road-slow' : 'motion-safe:animate-bus-road'"
            />

            <g v-for="sparkle in TRAIL" :key="sparkle.delay" :transform="`translate(${sparkle.x} ${sparkle.y})`">
                <path
                    d="M0 -3.6 L1 -1 L3.6 0 L1 1 L0 3.6 L-1 1 L-3.6 0 L-1 -1 Z"
                    fill="var(--color-fl-yellow-600)"
                    stroke="var(--color-fl-yellow-900)"
                    stroke-width="0.5"
                    stroke-linejoin="round"
                    class="motion-safe:animate-bus-trail origin-center opacity-0 [transform-box:fill-box]"
                    :style="{ animationDelay: sparkle.delay }"
                />
            </g>

            <g class="motion-safe:animate-bus-bounce">
                <rect
                    x="10"
                    y="2.5"
                    width="41"
                    height="18"
                    rx="4"
                    fill="var(--color-fl-blue-600)"
                    stroke="var(--color-fl-blue-900)"
                    stroke-width="0.8"
                />
                <rect v-for="x in SIDE_WINDOWS_X" :key="x" :x="x" y="5.5" width="6" height="6" rx="1.2" fill="var(--color-fl-blue-50)" />
                <path d="M43.5 5.5 h3.6 a2 2 0 0 1 2 2 v4 h-5.6 z" fill="var(--color-fl-blue-50)" />
                <rect x="10.4" y="14" width="40.2" height="2.2" fill="var(--color-fl-yellow-500)" />
                <circle cx="49.2" cy="18.2" r="1.2" fill="var(--color-fl-yellow-400)" />
            </g>

            <g
                v-for="cx in WHEEL_CENTERS_X"
                :key="cx"
                class="origin-center [transform-box:fill-box]"
                :class="isUphill ? 'motion-safe:animate-bus-wheel-slow' : 'motion-safe:animate-bus-wheel'"
            >
                <circle :cx="cx" cy="21" r="3.7" fill="var(--color-neutral-800)" />
                <circle :cx="cx" cy="21" r="1.5" fill="var(--color-neutral-100)" />
                <line :x1="cx" y1="17.6" :x2="cx" y2="24.4" stroke="var(--color-neutral-400)" stroke-width="0.9" />
            </g>
        </g>
    </svg>
</template>
